import PropTypes from "prop-types";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkRehype from "remark-rehype";
import rehypeRaw from "rehype-raw";
import RateMessage from "./RateMessage";
import {
    GREETING_SERVICE_SELECTION_SERVICE,
    IS_LOGIN,
    FIVE_MIN,
} from "../../../../constants";
import ServicesSelection from "../../molecules/ServicesSelection";
import QrcodeMessage from "./QrcodeMessage";
import QrcodeLoading from "./QrcodeLoading";
import { useSelector } from "react-redux";

BotMessage.propTypes = {
    message: PropTypes.object.isRequired,
};

export default function BotMessage({ message }) {
    const qrcodeUrl = useSelector((state) => state.session.qrcodeUrl);
    const isqrLoading = useSelector((state) => state.messages.isqrLoading);

    const markdownComponents = {
        h1: ({ children }) => <h1>{children}</h1>,
        h2: ({ children }) => <h2>{children}</h2>,
        p: ({ children }) => (
            <p style={{ margin: 0, marginBottom: 10 }}>{children}</p>
        ),
        a: ({ href, children }) => (
            <a
                href={href}
                style={{ color: "#2563eb", textDecoration: "none" }}
                onMouseOver={(e) =>
                    (e.currentTarget.style.textDecoration = "underline")
                }
                onMouseOut={(e) =>
                    (e.currentTarget.style.textDecoration = "none")
                }
                target="_blank"
                rel="noreferrer"
            >
                {children}
            </a>
        ),
        ul: ({ children }) => (
            <ul
                style={{
                    paddingInlineStart: "14px",
                    margin: 0,
                    marginBottom: 10,
                }}
            >
                {children}
            </ul>
        ),
        ol: ({ children }) => (
            <ol
                style={{
                    paddingInlineStart: "14px",
                    margin: 0,
                    marginTop: 5,
                    marginBottom: 10,
                }}
            >
                {children}
            </ol>
        ),
        li: ({ children }) => (
            <li
                style={{ display: "list-item", marginBottom: 10, marginTop: 5 }}
            >
                {children}
            </li>
        ),
        pre: ({ children }) => <span>{children}</span>,
        code: ({ children }) => (
            <p style={{ margin: 0, marginBottom: 10 }}>{children}</p>
        ),
        blockquote: ({ children }) => <blockquote>{children}</blockquote>,
        table: ({ children }) => <table className="table-bot">{children}</table>,
    };

    return (
        <li className="self">
            <div className="message">
                <Markdown
                    components={markdownComponents}
                    remarkPlugins={[remarkGfm, remarkRehype, rehypeRaw]}
                >
                    {message.content}
                </Markdown>
                {!message.rate_disabled && (
                    <RateMessage
                        id={message.conversation_id}
                        rate={message?.rate}
                    />
                )}
                {message.content === GREETING_SERVICE_SELECTION_SERVICE &&
                    message.user_id === "bot" &&
                    !IS_LOGIN && <ServicesSelection />}
                {isqrLoading && <QrcodeLoading />}
                {qrcodeUrl !== null && (
                    <QrcodeMessage url={qrcodeUrl} timeoutMs={FIVE_MIN} />
                )}
            </div>
            <span className="timestamp">
                {new Date(message.created_at).toLocaleString("en-US", {
                    hour: "numeric",
                    minute: "numeric",
                    hour12: true,
                })}
            </span>
        </li>
    );
}
